import { RouteProps } from "react-router-dom";
import { RoleEnum } from "../../interfaces/Roles";
import LoginPage from "../Login";
import PrivacyPage from "../Privacy";
import { adminPages, holderPages, officerPages } from "../pages";

interface RoutePropsExtended extends RouteProps {
  key: string;
}

export interface AppRoutesMap {
  [key: string]: RoutePropsExtended[];
}

export default {
  [RoleEnum.ADMIN]: [
    { path: "/holder", component: officerPages.HolderPage, key: "/holder" },
    { path: "/city", component: adminPages.CityPage, key: "/city" },
    {
      path: "/reservation-activities",
      component: holderPages.ReservationActivitiesPage,
      key: "/reservation-activities",
    },
    {
      path: "/beach/edit/:id",
      component: adminPages.BeachCreateUpdatePage,
      key: "/beach/edit/:id",
    },
    {
      path: "/beach/edit/",
      component: adminPages.BeachCreateUpdatePage,
      key: "/beach/edit/",
    },
    { path: "/beach/", component: adminPages.BeachPage, key: "/beach" },
    { path: "/officer", component: adminPages.OfficerPage, key: "/officer" },
    { path: "/privacy", component: PrivacyPage, key: "/privacy" },
  ],
  [RoleEnum.HOLDER]: [
    {
      path: "/beach",
      component: holderPages.BeachUpdatePage,
      key: "/beach",
    },
    { path: "/privacy", component: PrivacyPage, key: "/privacy" },
  ],
  [RoleEnum.OFFICER]: [],
  [RoleEnum.USER]: [],
  default: [
    { path: "/privacy", component: PrivacyPage, key: "/privacy" },
    { path: "/", component: LoginPage, key: "/" },
  ],
} as AppRoutesMap;
